<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <template v-if="revision">
          <p>Проверка ({{ revision.id }}) за <strong>{{ printDate(revision.created_at, 'HH:mm DD.MM.YYYY') }}</strong>
            <span v-if="revision.completed_at"> - продолжительность проверки <strong>{{
                printRevisionDuration()
              }}(s)</strong></span></p>
          <template v-if="revision.completed_at">
            <div class="text-right">
              <LoadingButton
                title="Запустить проверку"
                className="btn btn-outline-success"
                :onClick="() => startNewCheck()"
                :loading="loading"
                :color="$constants.SUCCESS_COLOR"
              />
            </div>
          </template>
          <template v-else>
            <LoadingButton
              title="Обновить статус проверки"
              className="btn btn-outline-info"
              :onClick="() => refreshCheck()"
              :loading="loading"
              :color="$constants.PRIMARY_COLOR"
            />
          </template>

        </template>
        <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
        <div v-if="!loading && records">
          <table class="table table-sm table-hover mt-2">
            <thead>
            <tr>
              <th></th>
              <th>Препарат</th>
              <th>Ошибка</th>
              <th>Склад</th>
              <th>Просчетный</th>
              <th>Актуальный</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, i) in records">
              <td>{{ i + 1 }}</td>
              <td>{{ record.drug.title }} ({{ record.drug.id }})</td>
              <td>{{ record.type_id === 2 ? 'Miss' : null }}</td>
              <td>({{ record.store_id }}) {{ $AllStores[record.store_id].title }}</td>
              <td>{{ record.calculated_qty }}</td>
              <td>{{ record.actual_qty }}</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import api from '@/api'
import moment from 'moment'
import LoadingButton from '@/components/buttons/LoadingButton'

export default {
  components: {
    LoadingButton
  },
  data () {
    return {
      loading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      revision: null,
      records: null,
    }
  },
  computed: {
    $AllStores () {
      return this.$store.getters['platform/stores']
    },
  },
  created () {
    this.getActualCheck()
  },
  methods: {
    async refreshCheck () {
      this.loading = true
      const { data } = await api.index('/revision/correction/' + this.revision.id)
      if (data.success) {
        const { records, ...revision } = data.revision
        if (revision.completed_at) {
          this.revision = revision
        }
        this.records = records
      } else {
        toastr['warning'](data.message || 'Ошибка')
      }
      this.loading = false
    },
    async startNewCheck () {
      this.loading = true
      const { data } = await api.index('/revision/correction/0')
      if (data.success) {
        const { records, ...revision } = data.revision
        this.revision = revision
        this.records = null
      } else {
        toastr['warning'](data.message || 'Ошибка')
      }
      this.loading = false
    },
    printRevisionDuration () {
      return moment(this.revision.completed_at).diff(moment(this.revision.created_at), 'seconds')
    },
    async getActualCheck () {
      this.loading = true
      this.records = null
      const { data } = await api.index('/revision/correction')
      if (data.success) {
        const { records, ...revision } = data.revision
        this.records = records
        this.revision = revision
      } else {
        toastr['warning'](data.message || 'Ошибка')
      }
      this.loading = false
    }
  }
}
</script>
